import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { sm: "12", lg: "5" } },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-3" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "font-weight-bold p-0" },
                        [_vm._v(_vm._s(_vm.texts.version) + " :")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-7" },
                    [
                      _c(VSelect, {
                        attrs: {
                          outlined: "",
                          dense: "",
                          items: _vm.profiling_executions,
                          "item-text": "format",
                          "item-value": "document_id",
                        },
                        model: {
                          value: _vm.currentExecution,
                          callback: function ($$v) {
                            _vm.currentExecution = $$v
                          },
                          expression: "currentExecution",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.profiling_execution.status
                    ? _c(VCol, { staticClass: "col-md-2" }, [
                        _c("strong", { style: { color: _vm.statusColor } }, [
                          _vm._v(
                            _vm._s(
                              this.profiling_execution.status.includes("STEP")
                                ? "ERROR AT " + this.profiling_execution.status
                                : this.profiling_execution.status
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.referenceRule !== null &&
          _vm.referenceRule.last_execution !== null &&
          Object.keys(this.referenceRule).length > 0
            ? _c(
                VCol,
                { attrs: { sm: "12", lg: "7" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold p-0" }, [
                    _vm._v(_vm._s(_vm.$t("frases.reference_score"))),
                    _c(
                      "strong",
                      {
                        class: _vm.scoreColor,
                        staticStyle: { "font-size": "20px" },
                        attrs: { id: "score-strong" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.referenceRule["last_execution"].resultsTable
                              .score + " / 100"
                          )
                        ),
                      ]
                    ),
                  ]),
                  _c(VSubheader, { staticClass: "font-weight-bold p-0" }, [
                    _vm._v("Last update at :"),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { title: "Last update at" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("stringShortFormatDateStick")(
                              "" +
                                this.referenceRule["last_execution"]
                                  .resultsTable.execution_date
                            )
                          )
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-form",
        { ref: "form", attrs: { disabled: "" }, on: { submit: _vm.onSubmit } },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "5" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.execution_date) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              disabled: "",
                              type: "datetime",
                            },
                            model: {
                              value: _vm.tableResult.execution_date,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableResult,
                                  "execution_date",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableResult.execution_date",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.rows_quantity) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VTextField, {
                            attrs: { outlined: "", dense: "", disabled: "" },
                            model: {
                              value: _vm.tableResult.q_rows,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableResult,
                                  "q_rows",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableResult.q_rows",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.table_key) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VTextField, {
                            attrs: { outlined: "", dense: "", disabled: "" },
                            model: {
                              value: _vm.tableResult.key,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tableResult,
                                  "key",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableResult.key",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-3" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.unique_key) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-9" },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              disabled: "",
                              value: _vm._f("formatPercent")(
                                _vm.tableResult.pct_key_ok
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "12", lg: "7" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-12" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.comments) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-12" },
                        [
                          _c(VTextarea, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rows: "5",
                              placeholder: _vm.texts.enter,
                              readonly: _vm.readonly,
                              required: true,
                            },
                            model: {
                              value: _vm.tableResult.commentary,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableResult, "commentary", $$v)
                              },
                              expression: "tableResult.commentary",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                [
                  _c(VTextField, {
                    staticClass: "mt-2",
                    attrs: {
                      outlined: "",
                      small: "",
                      dense: "",
                      placeholder: _vm.texts.search,
                      "append-outer-icon": "icon-search",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "prepend",
                        fn: function () {
                          return [
                            _c("label", [_vm._v(_vm._s(_vm.texts.filter))]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      items: _vm.tableResult.columns,
                      headers: _vm.fields,
                      search: _vm.filter,
                      "hide-default-footer":
                        Object.keys(_vm.tableResult.columns).length <= 10
                          ? true
                          : false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.pct_null",
                        fn: function (row) {
                          return [
                            row.item.pct_null !== null
                              ? _c("span", { staticClass: "mr-3" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatPercent")(row.item.pct_null)
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            row.item.ind_null !== null &&
                            row.item.ind_null === 0
                              ? _c("b-icon-arrow-right")
                              : _vm._e(),
                            row.item.ind_null !== null &&
                            row.item.ind_null === 1
                              ? _c("b-icon-arrow-up", {
                                  attrs: { variant: "success" },
                                })
                              : _vm._e(),
                            row.item.ind_null !== null &&
                            row.item.ind_null === -1
                              ? _c("b-icon-arrow-down", {
                                  attrs: { variant: "danger" },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.pct_empty_space",
                        fn: function (row) {
                          return [
                            row.item.pct_empty_space !== null
                              ? _c("span", { staticClass: "mr-3" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatPercent")(
                                        row.item.pct_empty_space
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            (row.item.ind_empty_space !== null) &
                            (row.item.ind_empty_space === 0)
                              ? _c("b-icon-arrow-right")
                              : _vm._e(),
                            (row.item.ind_empty_space !== null) &
                            (row.item.ind_empty_space === 1)
                              ? _c("b-icon-arrow-up", {
                                  attrs: { variant: "success" },
                                })
                              : _vm._e(),
                            (row.item.ind_empty_space !== null) &
                            (row.item.ind_empty_space === -1)
                              ? _c("b-icon-arrow-down", {
                                  attrs: { variant: "danger" },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.pct_unique_value",
                        fn: function (row) {
                          return [
                            row.item.pct_unique_value !== null
                              ? _c("span", { staticClass: "mr-3" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatPercent")(
                                        row.item.pct_unique_value
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            row.item.ind_unique_value !== null &&
                            row.item.ind_unique_value === 0
                              ? _c("b-icon-arrow-right")
                              : _vm._e(),
                            row.item.ind_unique_value !== null &&
                            row.item.ind_unique_value === 1
                              ? _c("b-icon-arrow-up", {
                                  attrs: { variant: "success" },
                                })
                              : _vm._e(),
                            row.item.ind_unique_value !== null &&
                            row.item.ind_unique_value === -1
                              ? _c("b-icon-arrow-down", {
                                  attrs: { variant: "danger" },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.pct_numeric",
                        fn: function (row) {
                          return [
                            row.item.pct_numeric !== null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatPercent")(
                                        row.item.pct_numeric
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.pct_freq_value",
                        fn: function (row) {
                          return [
                            row.item.pct_freq_value !== null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatPercent")(
                                        row.item.pct_freq_value
                                      )
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "thead-top",
                        fn: function (data) {
                          return [
                            _c(
                              "b-tr",
                              [
                                _c("b-th", {
                                  staticClass: "custom-border",
                                  attrs: { colspan: "2" },
                                }),
                                _c(
                                  "b-th",
                                  {
                                    staticClass:
                                      "custom-border text-center w-15",
                                    attrs: { colspan: "3" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("tablas.nullability")))]
                                ),
                                _c(
                                  "b-th",
                                  {
                                    staticClass:
                                      "custom-border text-center w-15",
                                    attrs: { colspan: "2" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("tablas.empty")))]
                                ),
                                _c(
                                  "b-th",
                                  {
                                    staticClass:
                                      "custom-border text-center w-15",
                                    attrs: { colspan: "1" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("tablas.unicity")))]
                                ),
                                _c(
                                  "b-th",
                                  {
                                    staticClass:
                                      "custom-border text-center w-15",
                                    attrs: { colspan: "2" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("tablas.numerical")))]
                                ),
                                _c(
                                  "b-th",
                                  {
                                    staticClass:
                                      "custom-border text-center w-15",
                                    attrs: { colspan: "2" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("tablas.freq")))]
                                ),
                                _c(
                                  "b-th",
                                  {
                                    staticClass:
                                      "custom-border text-center w-15",
                                    attrs: { colspan: "2" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("tablas.length")))]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                [
                  _c(VRow, { staticClass: "ml-0", attrs: { dense: "" } }, [
                    _vm._v(_vm._s(_vm.$t("frases.quantity"))),
                  ]),
                  _c(
                    VRow,
                    { staticClass: "ml-0" },
                    [
                      _c("b-icon-arrow-up", { attrs: { variant: "success" } }),
                      _vm._v(_vm._s(_vm.$t("frases.q_increased"))),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "ml-0", attrs: { dense: "" } },
                    [
                      _c("b-icon-arrow-down", { attrs: { variant: "danger" } }),
                      _c("b", [_vm._v(_vm._s(_vm.$t("frases.q_decreased")))]),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "ml-0", attrs: { dense: "" } },
                    [
                      _c("b-icon-arrow-right"),
                      _c("b", [_vm._v(_vm._s(_vm.$t("frases.q_same")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("dialog-confirmation-component", {
            ref: _vm.MODAL_CONFIRM_EDIT,
            attrs: {
              title: "CONFIRM EDIT PROFILING RULE",
              text: "Do you want to edit the comments of this execution?",
            },
            on: { onConfirm: _vm.onSubmit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }